// Banner configuration
// Set enabled to true/false to show/hide banners across the app
// This allows easy toggling without code changes

export const bannerConfig = {
  // Enable/disable banner display globally
  enabled: true,

  // Banner content configuration
  content: {
    // Type: 'news', 'ad', 'promotion', etc.
    type: 'ad',

    // Title text
    title: 'Путешествуй вместе',

    // Description text (optional)
    description: 'Создай поездку и найди компанию для своего следующего приключения',

    // Link URL (optional - if provided, banner becomes clickable)
    link: '/post-create', // e.g., '/giveaway' or 'https://example.com'

    // Link text (optional)
    linkText: 'Создать поездку',
    
    // Background color (optional - uses default if not provided)
    backgroundColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', // e.g., '#3ac693' or 'linear-gradient(180deg, #3ac693 0%, #2da883 100%)'
    
    // Text color (optional)
    textColor: '#ffffff', // e.g., '#ffffff'
    
    // Icon/emoji (optional)
    icon: '✈️', // Can be emoji or icon class
    
    // Dismissible - can users close the banner?
    dismissible: true,
    
    // Size: 'normal', 'large', 'hero'
    size: 'normal', // Use 'normal' for less intrusive banner
  },
  
  // Position: 'top' (fixed below header - best practice), 'content-top', 'content-bottom', 'bottom', 'side-left', 'side-right'
  position: 'top', // Best practice: fixed top banner below header
  
  // Show on desktop
  showOnDesktop: false,
  
  // Show on mobile
  showOnMobile: true,
  
  // Mobile display style: 'inline' (in content flow), 'popup' (modal overlay), or 'bottom' (bottom sheet - best practice)
  mobileStyle: 'bottom', // Best practice: bottom sheet on mobile
  
  // Pages where banner should appear (empty array = all pages)
  // Use pathnames like '/', '/profile', '/posts/:postId', etc.
  // Leave empty to show on all pages
  showOnPages: [], // e.g., ['/', '/profile'] or [] for all pages
  
  // Pages where banner should NOT appear
  excludePages: ['/login', '/register'], // Pages to exclude
};

// Example configurations for different banner types
export const bannerPresets = {
  // News/Promotion banner
  news: {
    type: 'news',
    title: 'Розыгрыш призов!',
    description: 'Участвуйте в розыгрыше и выиграйте незабываемое путешествие',
    link: '/giveaway',
    linkText: 'Участвовать',
    backgroundColor: 'linear-gradient(135deg, #3ac693 0%, #2da883 100%)',
    textColor: '#ffffff',
    icon: '🎁',
    dismissible: true,
    size: 'large',
  },
  
  // Advertisement banner
  ad: {
    type: 'ad',
    title: 'Специальное предложение!',
    description: 'Получите скидку 20% на все путешествия при бронировании до конца месяца',
    link: '/post-create',
    linkText: 'Создать поездку',
    backgroundColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    textColor: '#ffffff',
    icon: '✈️',
    dismissible: true,
    size: 'large',
  },
  
  // Hero banner (very large)
  hero: {
    type: 'hero',
    title: 'Найдите идеальное путешествие',
    description: 'Присоединяйтесь к тысячам путешественников и найдите компанию для вашего следующего приключения',
    link: '/post-create',
    linkText: 'Начать сейчас',
    backgroundColor: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    textColor: '#ffffff',
    icon: '🌍',
    dismissible: false,
    size: 'hero',
  },
};

// Helper function to check if banner should be displayed
export const isBannerEnabled = () => {
  return bannerConfig.enabled;
};

// Helper function to get banner content
export const getBannerContent = () => {
  return bannerConfig.content;
};

// Helper function to get banner position
export const getBannerPosition = () => {
  return bannerConfig.position;
};

// Helper function to check if banner should show on current page
export const shouldShowBannerOnPage = (currentPath) => {
  if (!bannerConfig.enabled) return false;
  
  // Check exclude list
  if (bannerConfig.excludePages.some(path => currentPath === path || currentPath.startsWith(path + '/'))) {
    return false;
  }
  
  // Check include list (if empty, show on all pages)
  if (bannerConfig.showOnPages.length > 0) {
    return bannerConfig.showOnPages.some(path => {
      // Handle dynamic routes like /posts/:postId
      if (path.includes(':')) {
        const pathPattern = path.replace(/:[^/]+/g, '[^/]+');
        const regex = new RegExp(`^${pathPattern}$`);
        return regex.test(currentPath);
      }
      return currentPath === path || currentPath.startsWith(path + '/');
    });
  }
  
  return true;
};
